<script>
	// export let colorScale;
	import { getColorScale } from "../../../colors";
	import { hovered, selected, selectedTopicId, selectedTopic } from "../stores";

	const layerLabels = {
		"bins-xlarge": "1km",
		"bins-large": "500m",
		"bins-medium": "250m",
		"bins-small": "125m",
	};

	export let activeLayer = "bins-large";

	$: colorScale = getColorScale($selectedTopicId);

	// $: gradientString = colorScale.map((c, i) => `${c} ${i*(colorScale.length)}%`)
</script>

<div class="legend">
	<div class="legend__title">Demo-Dichte je {layerLabels[activeLayer]}-Bereich</div>
	<div class="legend__inner-container">
		<div class="legend__text">wenige</div>
		<div
			class="legend__scale"
			style:background={`linear-gradient(270deg, ${colorScale[colorScale.length - 1]} 0%, ${colorScale[0]} 100%)`}
		/>
		<div class="legend__text">viele Demos</div>
	</div>
</div>

<style lang="scss">
	.legend {
		position: absolute;
		top: 30px;
		left: calc(330px + 0.5 * (100% - 330px));
		transform: translateX(-50%);
		z-index: 4;
		pointer-events: none;

		@media (max-width: $breakpoint-tablet-l) {
			top: 152px;
			left: 50%;
		}

		@media (max-width: $breakpoint-mobile-l) {
			left: 7px;
			transform: translateX(0);
		}

		&__inner-container {
			align-items: center;
			display: flex;
		}

		&__text {
			color: #b3b3b3;
			font-size: 12px;
			font-style: italic;
			font-weight: 400;
			line-height: normal;
		}

		&__scale {
			height: 10px;
			width: 100px;
			border-radius: 60px;
			margin: 0 7px;
			opacity: 0.9;
		}

		&__title {
			text-align: center;
			font-weight: $medium;
			font-size: 12px;
			line-height: normal;
			letter-spacing: 0.36px;
			color: #fff;
			margin-bottom: 3px;

			@media (max-width: $breakpoint-mobile-l) {
				text-align: left;
			}
		}
	}
</style>
